import { useCallback, useMemo, useState } from 'react';
import { z, ZodSchema } from 'zod';

export function useValidator(schema: ZodSchema) {
  const [errors, setErrors] = useState<Record<string, string>>({});

  const isValid = useMemo(() => Object.keys(errors).length === 0, [errors]);

  const validate = useCallback(
    (data: unknown) => {
      try {
        schema.parse(data);
        setErrors({});
        return true;
      } catch (error) {
        if (error instanceof z.ZodError) {
          setErrors(
            error.issues.reduce((acc: Record<string, string>, e) => {
              acc[e.path.join('.')] = e.message;
              return acc;
            }, {})
          );
        }
      }
      return false;
    },
    [schema]
  );

  return { validate, errors, isValid };
}
